"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var index_1 = __importStar(require("../Button/index"));

var ParentRow =
/** @class */
function (_super) {
  __extends(ParentRow, _super);

  function ParentRow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false
    };

    _this.toggleOpen = function () {
      _this.setState(function (_a) {
        var isOpen = _a.isOpen;
        return {
          isOpen: !isOpen
        };
      });
    };

    return _this;
  }

  ParentRow.prototype.render = function () {
    var isOpen = this.state.isOpen;
    var _a = this.props,
        children = _a.children,
        columns = _a.columns,
        value = _a.value,
        item = _a.item,
        selectableRows = _a.selectableRows,
        sortColumn = _a.sortColumn,
        onClick = _a.onClick;
    var openButton = react_1.default.createElement(index_1.default, {
      onClick: this.toggleOpen,
      variant: isOpen ? index_1.ButtonVariant.SecondaryBlue : index_1.ButtonVariant.Primary
    }, isOpen ? 'Zabalit' : 'Rozbalit');
    var columnsData = columns.map(function (column) {
      var columnValue = column.id !== 'action' ? value(item, column.id) : '';
      var columnData = column.childrenOpener ? openButton : columnValue;
      var className = classnames_1.default({
        sorted: sortColumn === column.id,
        children_opener: column.childrenOpener
      }, column.className || column.id, column.align || '');
      return react_1.default.createElement("td", {
        key: "parent_column-" + column.id,
        className: className
      }, columnData);
    });
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("tr", {
      className: "parent_row",
      onClick: onClick
    }, selectableRows && react_1.default.createElement("td", null), columnsData), isOpen && children);
  };

  return ParentRow;
}(react_1.default.Component);

exports.default = ParentRow;